import React from "react";
import { Box, Typography, Container } from "@mui/material";
import factoredLogo from "../../assets/images/factored_logo.png";

const MaintenancePage = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        src={factoredLogo}
        alt="Factored Logo"
        sx={{
          width: "250px",
          height: "auto",
          marginBottom: 4,
        }}
      />

      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: 600,
          color: "#333",
          marginBottom: 2,
        }}
      >
        We'll be back soon!
      </Typography>

      <Typography
        variant="h6"
        component="p"
        sx={{
          color: "#666",
          marginBottom: 3,
          maxWidth: "600px",
        }}
      >
        We're currently performing scheduled maintenance to improve your experience.
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "#888",
          maxWidth: "500px",
        }}
      >
        Thank you for your patience. If you have any urgent concerns, please contact our team.
      </Typography>
    </Container>
  );
};

export default MaintenancePage;
